// Redirecting to /logout from a page that itself runs authenticated queries
// (or is already tearing the session down) reloads it forever.
const NO_REDIRECT_ROUTES = ["/logout", "/login", "/auth-error"]

export function shouldRedirectToLogout(pathname: string): boolean {
	return !NO_REDIRECT_ROUTES.some((route) => pathname.startsWith(route))
}

export const WORKSPACE_DELETED_TOAST_ID = "workspace-deleted"
export const WORKSPACE_DELETED_TITLE = "This workspace was deleted"
export const WORKSPACE_DELETED_BODY =
	"Pick another workspace or create a new one."

export const LOGOUT_DELAY_MS = 2500

interface AuthError {
	data?: { code?: string; workspaceDeleted?: boolean } | null
}

export type AuthErrorAction = "ignore" | "logout" | "workspace-deleted"

/** What a failed request should do about the session behind it. */
export function resolveAuthErrorAction(
	error: AuthError,
	pathname: string,
): AuthErrorAction {
	if (error.data?.code !== "UNAUTHORIZED") return "ignore"
	if (!shouldRedirectToLogout(pathname)) return "ignore"
	return error.data.workspaceDeleted ? "workspace-deleted" : "logout"
}
